import { render, staticRenderFns } from "./DrinkPlanOption.vue?vue&type=template&id=0520ebbc&scoped=true&"
import script from "./DrinkPlanOption.vue?vue&type=script&lang=js&"
export * from "./DrinkPlanOption.vue?vue&type=script&lang=js&"
import style0 from "./DrinkPlanOption.vue?vue&type=style&index=0&id=0520ebbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0520ebbc",
  null
  
)

export default component.exports